module.exports = __webpack_public_path__ + "img/payment_income.298879f9.jpg";